const expand = {
  position: { select: 'id,name' },
  userGroup: { select: 'id,name' },
};

/**
 * OData select/expand for global user-group approvers (by position).
 * Used by createCrudModel via CoreQueries.GlobalUserGroupApproverByPosition.
 */
export default {
  paged: {
    select: 'id,approvalLevel',
    notSelectSearch: 'approvalLevel',
    expand,
  },
  item: {
    select: 'id,approvalLevel',
    expand,
  },
  itemDetail: {
    select: 'id,approvalLevel,updated,created',
    expand: {
      ...expand,
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
